import { createGlobalStyle } from "styled-components";
// import { isMobile } from "react-device-detect";
// import "@fontsource/roboto-serif/300.css";
// import "@fontsource/roboto-serif/400.css";
// import "@fontsource/roboto-serif/500.css";
// import "@fontsource/roboto-serif/700.css";
// import "@fontsource/chicle/400.css";
import { light } from "../../themes";

const GlobalStyles = createGlobalStyle`
		
		:root {
			${({ theme }) => 
							Object.keys(light).map((k) =>
											`--d8s-${k}: ${theme[k]};`).join("\n")}
		}
		
    html {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        font-family: Arial, sans-serif;
		    color: var(--d8s-primary);
    }

    #root {
        height: 100vh;
        width: 100%;
    }

    *, *::before, *::after {
        box-sizing: inherit;
        font-family: Arial, Serif;
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;

export default GlobalStyles;
